export const PATHS = {
  // Main routes
  ROOT: "/",
  PUBLISHER_HUB: "/publisher-hub",
  PLAYLISTS: "/playlists",
  REPORTING: "/reporting",

  MEDIA_GALLERY: "/media-gallery",
  SINGLE_MEDIA_EDIT_PAGE: "/video/edit/:token",
  MEDIA_GALLERY_PLAYLISTS: "/media-gallery?tab=1",
  SINGLE_PLAYLIST_EDIT_PAGE: "/playlist/edit/:token",

  // Admin routes
  ADMIN: "/admin",
  EDIT: "/edit",
  CLONE: "/clone",
  ADMIN_USERS: "/admin/users",
  ADMIN_DOMAIN: "/admin/:slug/domain",
  ADMIN_PUBLISHER_ONBOARD: "/admin/publisher/onboard",
  ADMIN_BULK_UPDATE: "/admin/bulk-update",
  ADMIN_BULK_DELETE: "/admin/bulk-delete",

  // admin dynamic routes
  ADMIN_DOMAIN_CONFIG: "/admin/:slug/domain/:domainToken",
  ADMIN_CONFIG_EDIT: "/admin/:slug/domain/:domainToken/add-config/edit",
  ADMIN_PLAYER_CONFIG: "/admin/:slug/domain/:domainToken/:playerToken",
  ADMIN_PLAYER_EDIT: "/admin/:slug/domain/:domainToken/:playerToken/edit",
  ADMIN_REVISION_EDIT:
    "/admin/:slug/domain/:domainToken/:playerToken/:revision/edit",
  ADMIN_PLAYER_CLONE: "/admin/:slug/domain/:domainToken/:playerToken/clone",

  // Bulk and not found
  BULK_EDIT: "/bulk",
  NOT_FOUND: "*",
};
